const global = {}

// 退出登录跳转判断
global.logoutJump = function (store, router) {
  store.dispatch('user/logout').then(() => {
    if (['forbidden', 'page-not-found', 'login'].includes(router.currentRoute.name)) {
      return router.push({ name: 'login' })
    }
    return router.push({ name: 'login' })
    // return router.push({ name: 'login', 'query': { redirect: encodeURIComponent(location.href) }})
  })
}

// 复制对象方法
global.clone = function (obj) {
  // 处理三件简单类型 已经null或者undefined
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // 处理日期
  if (obj instanceof Date) {
    let copy = new Date()
    copy.setTime(obj.getTime())
    return copy
  }

  // 处理数组
  if (obj instanceof Array) {
    let copy = []
    const len = obj.length
    for (let i = 0; i < len; i++) {
      copy[i] = global.clone(obj[i])
    }
    return copy
  }

  // 处理对象
  if (obj instanceof Object) {
    let copy = {}
    for (const attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = global.clone(obj[attr])
    }
    return copy
  }

  throw new Error(global.t('m.obj_copy_failed'))
}

// 全局常量
global.Enum = {}


// 判断是否是空对象
global.isEmptyObject = function (obj) {
  for (const key in obj) {
    return false // 返回false，不为空对象
  }
  return true // 返回true，为空对象
}


// 检验是否为空
global.checkNotEmpty = function (value) {
  return value
}

// 检验是否是数字
global.checkDigits = function (value) {
  const type = '^[0-9]*[1-9][0-9]*$'
  const r = new RegExp(type)
  return r.test(value)
}

// 检验是否是空数组
global.checkNotEmptyArray = function (value) {
  if (typeof value !== 'object' || value.length === 0) {
    return false
  } else {
    for (let i = 0; i < value.length; i++) {
      if (!value[i]) {
        return false
      }
    }
  }
  return true
}

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
global.formatDateTime = function (date, fmt) {
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}

// 获取两个日期之间相隔的天数 日期格式 2020-10-10 2020/10/10
global.checkTimeBetween = function (starDate, endDate) {
  let sDate = new Date(starDate).getTime()
  let eDate = new Date(endDate).getTime()

  if (!sDate || !eDate) {
    return 0
  }
  return Math.ceil((eDate - sDate) / (86400 * 1000))
}

// element-ui 时间组件 快速选项配置
global.searchDateConfig = {
  shortcuts: [{
    text: '今天',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      let s = new Date(new Date().toLocaleDateString()).getTime()
      start.setTime(s)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '昨天',
    onClick (picker) {
      let time = new Date(new Date().toLocaleDateString()).getTime()
      let s = time - 3600 * 24 * 1000
      let e = time - 1
      const end = new Date()
      const start = new Date()
      start.setTime(s)
      end.setTime(e)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近3天',
    onClick (picker) {
      let time = new Date(new Date().toLocaleDateString()).getTime()
      let s = time - 3600 * 24 * 1000 * 2
      const end = new Date()
      const start = new Date()
      start.setTime(s)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一周',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一个月',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  }]
}


// 获取今天之前的天数的日期 如2020-10-10
global.getDayData = function (day = 0) {
  let dayNow = new Date()
  let dayTime = new Date()
  dayTime.setTime(dayNow.getTime() - day * 86400 * 1000)

  // 补0
  let m = dayTime.getMonth() + 1
  let d = dayTime.getDate()
  if (m < 10) {
    m = '0' + m
  }
  if (d < 10) {
    d = '0' + d
  }

  return dayTime.getFullYear() + '-' + m + '-' + d
}


// 连字符- 转驼峰式
global.cssStyle2DomStyle = function (sName) {
  return sName.replace(/^-/, '').replace(/-(\w)(\w+)/g, function (a, b, c) {
    return b.toUpperCase() + c.toLowerCase()
  })
}

// 小数转成整数
global.formatPercentForInteger = function (number) {
  return Math.round(number * 100)
}

// HTML标签转义（< -> &lt;）
global.html2Escape = function (sHtml) {
  var temp = document.createElement('div');
  (temp.textContent != null) ? (temp.textContent = sHtml) : (temp.innerText = sHtml)
  var output = temp.innerHTML
  temp = null
  return output
}

// HTML标签反转义（&lt; -> <）
global.escape2Html = function (str) {
  var temp = document.createElement('div')
  temp.innerHTML = str
  var output = temp.innerText || temp.textContent
  temp = null
  return output
}

// 获取cookie值
global.getCookie = function(key) {
  var strcookie = document.cookie; //获取cookie字符串
  var arrcookie = strcookie.split("; "); //分割
  //遍历匹配
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split("=");
    if (arr[0] == key) {
      return arr[1];
    }
  }
  return ""
}

// TODO 可以写到工具中

export default global
